/* eslint-disable react/prop-types */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars*/
import { Grid, TextField } from "@material-ui/core/";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { dateConfig } from "config";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getProjectDetailsByCountry } from "redux/actions/appActions";
import { getWorkersByMgr } from "services";
import { getLocationForCountry } from "services/bulkUpload";
import { getProjectsByCountry } from "services/index";
import { getEndOfWeek, jobTypeITContractor } from "utils";
import WeekPicker from "../../Review/components/WeekPicker";
import { getWeekError } from "./utils";
import FormControl from "@material-ui/core/FormControl";
import {
  getWorkerIMTimeRole,
  getWorkerSchedule
} from "services/workerSchedule";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  formControl: {
    minWidth: "200px",
  },
}));

const DropDowns = (props) => {
  const {
    onChangeSelections,
    loading,
    reset,
    setLoading,
    disabled,
    record,
    index,
    register,
    control,
    onUpdate,
    setValue,
    trigger,
    errors,
    getValues,
    locationProps,
    setWorkerShedule
  } = props;

  const classes = useStyles();

  const { t } = useTranslation();
  const { user } = useSelector((state) => state.user.auth);
  const { selectedWeekOnReview, deviceCountry } = useSelector(
    (state) => state.appConfig
  );
  const { selectedManagerForApproval } = useSelector(
    (state) => state.appConfig
  );

  const [workers, setWorkers] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [deviceDistricts, setDeviceDistricts] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const [imtRole, setImtRole] = useState("");
  const [week, setWeek] = React.useState(
    selectedWeekOnReview
      ? moment(selectedWeekOnReview.week)
          .startOf("week")
          .format(dateConfig.format6)
      : moment().startOf("week").format(dateConfig.format6)
  );
  const [selectedWorker, setSelectedWorker] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedBuilding, setSelectedBuilding] = useState("");
  const dispatch = useDispatch();
  const customerSiteLabel = t("pgPunch.phCustomerSite") + "*";
  useEffect(() => {
    // Get all My Workers
    if (user && user.workerId) {
      console.log("trell", locationProps);
      let userWorkerId = user.workerId;
      setLoading(true);
      //show the selected worker on timesheet page
      if (locationProps && locationProps.worker) {
        console.log("trell 1", locationProps);
        userWorkerId = locationProps.worker.managerId;
      }
      //from all selection
      if (locationProps && locationProps.workers.length != 0) {
        console.log("trell 2", locationProps);
        userWorkerId = locationProps.workers[0].managerId;
      }
      if (
        locationProps &&
        locationProps.workers &&
        locationProps.workers.length == 0
      ) {
        console.log("trell 3", locationProps);
        userWorkerId = selectedManagerForApproval;
      }

      getWorkerIMTimeRole(user.workerId).then((logindata) => {
        setImtRole(logindata.role);
      getWorkersByMgr(userWorkerId)
        .then((data) => {
          console.log(`getWorkersByMgr for ${user.workerId} = data=`, data);
          let active = [];
          //When user directly navigates to add-timesheet, it should render, if data exists then show that otherwise empty options in worker
          if (data !== false) {
            for (let i = 0; i < data.workers.length; i++) {
               const jobType = data.workers[i].jobType ? data.workers[i].jobType : "";
                if (data.workers[i].isActiveWorker && jobType !== jobTypeITContractor) {
                active.push(data.workers[i]);
              }
            }
          }
          //sorting the workers name in workers dropdown
          active.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : a.name.toLowerCase() === b.name.toLowerCase()
              ? a.workerId > b.workerId
                ? 1
                : -1
              : -1
          );
          let delegateFor = user?.delegateFor;
          if ((!(delegateFor && userWorkerId &&
            delegateFor.includes(userWorkerId))) &&
            ((logindata.role && logindata.role !== "" && logindata.role.toLowerCase() === "supervisor" && user.workerId !== userWorkerId)
              || (!logindata.role && user && user.isApprover && user.workerId !== userWorkerId))) {

            active = active.length > 0 && active.filter(item => item.approvingManager && item.approvingManager.includes(user.workerId))
          }
          setWorkers(active);
          setLoading(false);
          if (
            locationProps &&
            locationProps.worker &&
            !locationProps.allPunches
          ) {
            setValue("selectedWorker", locationProps.worker);
            setSelectedWorker(locationProps.worker);
          }

          // dispatch(setAllMyWorkers(data.workers));
        })
      })
        .catch((err) => {
          // setLoading(false);
          console.error("BulkEntry: Err in getWorkerByMgr Response: ", err);
        });
    }
  }, [user]);

  // useEffect(() => {
  //   if (deviceCountry)
  //     getLocationForCountry(deviceCountry)
  //       .then((data) => {
  //         // console.log("Data", data);
  //         setLoading(false);
  //         setDeviceDistricts(data);
  //       })
  //       .catch(() => {
  //         setLoading(false);
  //         // console.log("BulkEntry: Err loading locations data");
  //       });
  // }, [deviceCountry]);

  // useEffect(() => {
  //   if (deviceDistricts.length > 0)
  //     setDistricts((c) => [...deviceDistricts, ...c]);
  // }, [deviceDistricts]);

  useEffect(() => {
    console.log("device worker", selectedWorker);
    if (selectedWorker && selectedWorker.countryCode) {
      setLoading(true);
      if (selectedWorker.country === "testCountry") {
        selectedWorker.countryCode = "testCountry";
      }
      // if (
      //   deviceCountry.toLowerCase() === selectedWorker.countryCode.toLowerCase()
      // ) {
      //   setDistricts([...deviceDistricts]);
      // } else {
      getLocationForCountry(selectedWorker.countryCode)
        .then((data) => {
          // console.log("Data", data);
          setLoading(false);
          setDistricts([...data]);
        })
        .catch(() => {
          setLoading(false);
          console.log("BulkEntry: Err loading locations data");
        });
       // if(selectedWorker.timezone && Object.keys(selectedWorker.timezone).length>0){
          getWorkerSchedule(selectedWorker.workerId).then((data)=>{
             console.log("device worker", data);
             setWorkerShedule(data);
          }).catch((err)=>{
            setLoading(false);
            console.log("BulkEntry: Err loading worker schedule data", err);
          });
        // }

      // }
    } else {
      setDistricts([]);
    }
  }, [selectedWorker]);

  useEffect(() => {
    if (selectedWorker) {
      setLoading(true);
      getProjectsByCountry(selectedWorker.country)
        .then((data) => {
          if (data) {
            setLoading(false);
            dispatch(getProjectDetailsByCountry(data));
          }
        })
        .catch((err) => {
          console.error("No response from getProjectDetailsByCountry:: ", err);
        });
    }
  }, [selectedWorker]);

  const weekChangeHandler = (date) => {
    const weekStart = moment(date).format(dateConfig.format6);
    const weekEnd = getEndOfWeek(weekStart);
    setWeek(weekStart);
    setValue("weekStart", weekStart);
    setValue("weekPicker", weekStart);
    setValue("weekEnd", weekEnd);
    onUpdate();
  };

  useEffect(() => {
    const weekStart = moment(week).format(dateConfig.format6);
    const weekEnd = getEndOfWeek(weekStart);
    setWeek(weekStart);
    setValue("weekStart", weekStart);
    setValue("weekPicker", weekStart);
    setValue("weekEnd", weekEnd);
  }, [week]);
  useEffect(() => {
    const weekEnd = getEndOfWeek(week);
    onChangeSelections({
      weekStart: week,
      weekEnd,
      district: selectedDistrict,
      building: selectedBuilding,
      selectedWorker,
    });
  }, [week, selectedWorker, selectedDistrict, selectedBuilding]);

  useEffect(() => {
    const weekStart = moment().startOf("week").format(dateConfig.format6);
    const weekEnd = getEndOfWeek(weekStart);
    register("weekStart");
    register("weekEnd");
    setValue("weekStart", weekStart);
    setValue("weekEnd", weekEnd);
  }, []);

  return (
    <Grid container className={classes.root} spacing={2} alignItems="center">
      <Grid item>
        {/* <WeekPicker lbl={"Select Week"} weekChangeHandler={weekChangeHandler} /> */}
        <Controller
          name="weekPicker"
          control={control}
          render={({ onChange, value }) => (
            <WeekPicker
              lbl={t("other.timeSheetWeekSelector")}
              selected={value}
              startDate={week}
              weekChangeHandler={weekChangeHandler}
              maxDate={moment().add(1, "years")}
              minDate={moment().subtract(2, "weeks")}
            />
          )}
        />
      </Grid>
      <Grid item>
        <Controller
          render={(props) => (
            <Autocomplete
              className={classes.formControl}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              fullWidth
              //disableClearable
              value={selectedWorker}
              defaultValue={{ value: selectedWorker }}
              options={workers}
              getOptionLabel={(option) =>
                option.name ? option.name + " (" + option.workerId + ")" : ""
              }
              renderInput={(params) => (
                <TextField
                  label={t("other.timeSheetWorkerDropdown")}
                  {...params}
                  {...props}
                  InputProps={{
                    ...params.InputProps,
                  }}
                  placeholder={t("other.timeSheetWorkerDropdown")}
                  error={getWeekError(errors, "selectedWorker")}
                />
              )}
              onInputChange={(event, newValue) => {
                if (!newValue) {
                  // setWorkers([]);
                  props.onChange(newValue);
                  setSelectedWorker("");
                  setDistricts([]);
                  setSelectedDistrict("");
                  setBuildings([]);
                  setSelectedBuilding("");
                  reset();
                }
              }}
              onChange={(event, newValue) => {
                props.onChange(newValue);
                if (newValue) {
                  setWorkerShedule({});
                  if (newValue.country !== selectedWorker.country) {
                    setSelectedWorker(newValue);
                    setSelectedDistrict("");
                    setSelectedBuilding("");
                    reset();
                  }
                  if (newValue.country === selectedWorker.country) {
                    setSelectedWorker(newValue);
                  }
                  onUpdate(index, -1);
                }
              }}
            />
          )}
          name="selectedWorker"
          control={control}
          //defaultValue={selectedWorker}
        />
      </Grid>
      <Grid item>
        <Controller
          render={(props) => (
            <Autocomplete
              disabled={loading || !selectedWorker}
              className={classes.formControl}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              fullWidth
              //disableClearable
             // value={{ district: "selectedDistrict" }}
              value={selectedDistrict}
              defaultValue={{ selectedDistrict }}
              options={districts}
              getOptionLabel={(option) => option.district}
              renderInput={(params) => (
                <TextField
                  label={t("other.timeSheetDIstrictDropdown")}
                  {...params}
                  {...props}
                  InputProps={{
                    ...params.InputProps,
                  }}
                  placeholder={t("other.timeSheetDIstrictDropdown")}
                  error={getWeekError(errors, "districtId")}
                />
              )}
              onInputChange={(event, newValue) => {
                props.onChange(newValue);
                if (!newValue) {
                  //setDistricts([]);
                  setSelectedDistrict("");
                  setBuildings([]);
                  setSelectedBuilding("");
                }
              }}
              onChange={(event, newValue) => {
                if (newValue) {
                  const tempbuild = newValue.buildings;
                  let activatedBuilding = Object.keys(tempbuild).filter(
                    (e) => tempbuild[e].activityEnabled === true
                  );

                  if (newValue && newValue.district) {
                    props.onChange(newValue.district);
                  }
                  if (newValue && newValue.buildings) {
                    //setSelectedDistrict(newValue.district);
                    setSelectedDistrict(newValue);
                    selectedWorker.isApprover
                      ? setBuildings([
                          ...activatedBuilding,
                          "Customer Site",
                          "Remote",
                        ])
                      : setBuildings([...activatedBuilding, "Customer Site"]);
                    setSelectedBuilding("");
                  }
                }

                //  if (newValue.country === selectedWorker.country) {
                //  setSelectedWorker(newValue);
                // }
                onUpdate(index, -1);
                trigger();
              }}
            />
          )}
          name="districtId"
          control={control}
        />
      </Grid>
      <Grid item>
        <Controller
          render={(props) => (
            <Autocomplete
              className={classes.formControl}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              fullWidth
              //disableClearable
              value={selectedBuilding}
              defaultValue={{ value: props.value }}
              options={buildings}
              loading={buildings.length == 0}
              disabled={loading || !selectedWorker || !selectedDistrict}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField
                  label={t("other.timeSheetBuildingDropdown")}
                  {...params}
                  {...props}
                  InputProps={{
                    ...params.InputProps,
                  }}
                  placeholder={t("other.timeSheetBuildingDropdown")}
                  error={getWeekError(errors, "buildingId")}
                />
              )}
              onInputChange={(event, newValue) => {
                props.onChange(newValue);
                if (!newValue) {
                  // setBuildings([]);
                  setSelectedBuilding("");
                }
              }}
              onChange={(event, newValue) => {
                props.onChange(newValue);
                if (newValue) {
                  setSelectedBuilding(newValue);
                  onUpdate(index, -1);
                }
                trigger();
              }}
            />
          )}
          name="buildingId"
          control={control}
        />
      </Grid>
      {selectedBuilding === "Customer Site" && (
        <Grid item>
          <FormControl className={classes.formControl} fullWidth>
            <TextField
              label={customerSiteLabel}
              placeholder={customerSiteLabel}
              fullWidth
              size="small"
              variant="standard"
              inputRef={register()}
              name="customerSite"
              error={getWeekError(errors, "customerSite")}
              defaultValue={""}
              onChange={() => trigger()}
            />
          </FormControl>
        </Grid>
      )}
    </Grid>
  );
};

DropDowns.propTypes = {
  onChangeSelections: PropTypes.func,
  setLoading: PropTypes.func,
  loading: PropTypes.bool,
  onUpdate: PropTypes.func,
};

export default DropDowns;
